'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DocumentKind$() {
  this.c65 = null;
  this.c66 = false;
}
export { $c_Lpresto_types$DocumentKind$ as $c_Lpresto_types$DocumentKind$ };
$p = $c_Lpresto_types$DocumentKind$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DocumentKind$;
/** @constructor */
function $h_Lpresto_types$DocumentKind$() {
}
export { $h_Lpresto_types$DocumentKind$ as $h_Lpresto_types$DocumentKind$ };
$h_Lpresto_types$DocumentKind$.prototype = $p;
$p.adw = (function() {
  if ((!this.c66)) {
    this.c65 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c66 = true;
  }
  return this.c65;
});
var $d_Lpresto_types$DocumentKind$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DocumentKind$, "presto.types$DocumentKind$", ({
  ZL: 1,
  D: 1
}));
export { $d_Lpresto_types$DocumentKind$ as $d_Lpresto_types$DocumentKind$ };
var $n_Lpresto_types$DocumentKind$;
function $m_Lpresto_types$DocumentKind$() {
  if ((!$n_Lpresto_types$DocumentKind$)) {
    $n_Lpresto_types$DocumentKind$ = new $c_Lpresto_types$DocumentKind$();
  }
  return $n_Lpresto_types$DocumentKind$;
}
export { $m_Lpresto_types$DocumentKind$ as $m_Lpresto_types$DocumentKind$ };
//# sourceMappingURL=presto.types$-Document-Kind$.js.map
